import * as React from "react";

const CloseIcon: React.FC<{ size?: number }> = ({ size = 56 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
            <path
                d="M7.27969 6.2209C7.57266 6.51387 7.57266 6.98848 7.27969 7.28145C7.13438 7.42793 6.94219 7.50059 6.75 7.50059C6.55781 7.50059 6.36609 7.42734 6.21984 7.28086L3.75 4.8123L1.28039 7.28027C1.13391 7.42793 0.941953 7.50059 0.75 7.50059C0.558047 7.50059 0.366328 7.42793 0.219727 7.28027C-0.0732422 6.9873 -0.0732422 6.5127 0.219727 6.21973L2.69004 3.74941L0.219727 1.28027C-0.0732422 0.987305 -0.0732422 0.512695 0.219727 0.219727C0.512695 -0.0732422 0.987305 -0.0732422 1.28027 0.219727L3.75 2.69121L6.22031 0.220899C6.51328 -0.0720702 6.98789 -0.0720702 7.28086 0.220899C7.57383 0.513867 7.57383 0.988476 7.28086 1.28145L4.81055 3.75176L7.27969 6.2209Z"
                fill="#0F96D9"
            />
        </svg>
    );
};
``;

export default React.memo(CloseIcon);
